import React from 'react';
import Hero from './Hero';
import Sora2Generator from './Sora2Generator';
import Examples from './Examples';
import Features from './Features';
import Steps from './Steps';
import FAQ from './FAQ';
import './Sora2.scss';

export default function Sora2() {
  return (
    <div className="sora2-page">
      <Hero />
      <Sora2Generator />
      <Examples />
      <Features />
      <Steps />
      <FAQ />
    </div>
  );
}